// 日本語

export default {
    'About': '',
    'Company': '',
    'Contact': '',
    'Email Address': '',
    'First Name': '',
    'Get In Touch': '',
    'Manage Cookies': '',
    'Media Kit': '',
    'Newsroom': '',
    'Password': '',
    'Privacy Policy': '',
    'Related Case Studies': '',
    'Related Resources': '',
    'See Case Study': '',
    'Sign up': '',
    'Submit': '',
    'The Goal': '',
    'View All': '',
    'You are missing one or more requred fields': ''
};
